type FieldRoutesEntity =
  | 'customer'
  | 'serviceType'
  | 'appointment'
  | 'note'
  | 'route'
  | 'employee'
  | 'skill'
  | 'subscription';

/**
 * Parse the FieldRoutes entity ID from a solea external ID
 *
 * Forma: office_id|entity_type=entity_id
 * Example: '1c3fc008-edf2-46bf-8c6d-65dd5db1b5cc|customer=133465'
 *
 * @returns fields routes entity ID
 */
export function parseExternalId(externalId: string | null | undefined, frType: FieldRoutesEntity) {
  if (!externalId) {
    return null;
  }

  const parts = externalId.split('|');
  for (const part of parts) {
    if (part.includes(frType) && part.includes('=')) {
      return part.split('=')[1];
    }
  }

  return null;
}
